import { render, staticRenderFns } from "./questionnaireEmailTab.vue?vue&type=template&id=62b782c2&"
import script from "./questionnaireEmailTab.vue?vue&type=script&lang=js&"
export * from "./questionnaireEmailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports